import { Config } from '../config';

export const baseMetadataQueryParamsAllowlist = ['lang'];

export const getMetadataQueryParamsAllowlist = (
  siteSpecificAllowlist: string[] = Config.metadataQueryParamsAllowlist ?? []
): Set<string> => new Set([...baseMetadataQueryParamsAllowlist, ...siteSpecificAllowlist]);

/**
 * Returns a URL suitable for canonical/hreflang metadata by dropping all query params except an
 * allowlist and always removing hash.
 */
export const filterMetadataUrl = (
  currentUrl: string,
  queryParamsAllowlist: Set<string> = getMetadataQueryParamsAllowlist()
): URL => {
  const originalUrl = new URL(currentUrl);
  const filteredUrl = new URL(originalUrl.href);

  filteredUrl.hash = '';
  filteredUrl.search = '';

  for (const [key, value] of originalUrl.searchParams.entries()) {
    if (queryParamsAllowlist.has(key)) {
      filteredUrl.searchParams.append(key, value);
    }
  }

  return filteredUrl;
};
